import React from 'react'
import { string } from 'prop-types'
import { styled } from '@creditas/stylitas'
import { matchedRegions } from './helpers'

const Highlight = styled.strong`
  font-weight: 700;
`

const TextHighlight = ({ text, search }) => {
  text = typeof text === 'string' ? text : ''
  search = typeof search === 'string' ? search : ''

  const matches = matchedRegions(text, search)
  const output = []

  if (matches.length === 0) {
    return text
  }

  if (matches[0][0] !== 0) {
    output.push({
      type: 'normal',
      region: `(0,${matches[0][0]})`,
      string: text.substring(0, matches[0][0]),
    })
  }

  for (let i = 0; i < matches.length; i++) {
    const region = matches[i]
    output.push({
      type: 'highlight',
      region: `(${region[0]},${region[1] + 1})`,
      string: text.substring(region[0], region[1] + 1),
    })

    if (i < matches.length - 1) {
      const nextRegion = matches[i + 1]
      output.push({
        type: 'normal',
        region: `(${region[1] + 1},${nextRegion[0]})`,
        string: text.substring(region[1] + 1, nextRegion[0]),
      })
    } else if (region[1] !== text.length - 1) {
      output.push({
        type: 'normal',
        region: `(${region[1] + 1},${text.length})`,
        string: text.substring(region[1] + 1, text.length),
      })
    }
  }

  return output.map(part =>
    part.type === 'highlight' ? (
      <Highlight key={part.region}>{part.string}</Highlight>
    ) : (
      part.string
    ),
  )
}

TextHighlight.propTypes = {
  text: string.isRequired,
  search: string.isRequired,
}

export { TextHighlight }
